module.exports = __webpack_public_path__ + "static/media/trello.459551bc.svg";